<template>
  <div class="component-content sub-content">
    <div class="project-detail" v-if="project">
      <h1>
        <div class="r">
          <el-button
            @click="projectStatusUpdateCancle()"
            size="small"
            v-if="backRole('PM_7')"
            type="danger"
            >废弃该项目
          </el-button>

          <el-button
            @click="deleteProject()"
            size="small"
            v-if="project.status == '申请中' && isLeader"
            type="danger"
            >删除项目
          </el-button>
        </div>

        <span class="approval-type at3" v-if="project.type == 3"
          >微型工程(B类)</span
        >
        <span class="approval-type at3" v-else-if="project.type == 4"
          >原水微型工程(B类)</span
        >
        <span class="approval-type at3" v-else-if="project.wxType == 'A'"
          >微型工程(A类)</span
        >
        <span class="approval-type at2" v-else>工程</span>
        {{ project.name }}
        <el-button
          @click="editProjectInfo()"
          v-if="isLeader"
          type="warning"
          class="h1-edit"
          icon="el-icon-edit"
          circle
        >
        </el-button>
        <span class="status">当前状态：{{ project.status }}</span>
      </h1>
      <div
        class="intro"
        v-html="project.intro.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>')"
      ></div>
      <div class="info">
        <div class="info-content">
          <div class="info-item">
            <label>所属公司：</label>
            <span class="cont">{{ project.deptName }}</span>
          </div>
          <div class="info-item">
            <label>项目创建者：</label>
            <span class="cont">{{
              project.creator.name +
              "/" +
              (project.creator.telephone
                ? project.creator.telephone
                : project.creator.mobile)
            }}</span>
          </div>
          <div class="info-item">
            <label>实施类别：</label>
            <span class="cont">{{ project.sslb }}</span>
          </div>
        </div>
        <div class="info-content">
          <div class="info-item">
            <label>项目编号：</label>
            <span class="cont">{{ project.number }}</span>
          </div>
          <div class="info-item" v-if="project.lxpwh">
            <label>立项批文号：</label>
            <span class="cont">{{ project.lxpwh }}</span>
          </div>
          <div class="info-item" v-if="project.htbh">
            <label>合同编号：</label>
            <span class="cont">{{ project.htbh }}</span>
          </div>
        </div>
        <div class="info-content">
          <div class="info-item info-item2">
            <label>项目负责人：</label>
            <span class="cont">{{
              project.leader.name +
              "/" +
              (project.leader.telephone
                ? project.leader.telephone
                : project.leader.mobile)
            }}</span>
            <el-button
              v-if="isLeader"
              @click="addUsers(1)"
              style="margin-left: 10px"
              round
              size="mini"
              type="primary"
            >
              更换</el-button
            >
          </div>
        </div>
        <div class="info-content">
          <div class="info-item info-item2">
            <label>进度款审核负责人：</label>
            <span class="cont">{{
              project.kxLeader
                ? project.kxLeader.name + " / " + project.kxLeader.telephone
                : "未设置"
            }}</span>
            <el-button
              v-if="isLeader"
              @click="addUsers(2)"
              style="margin-left: 10px"
              round
              size="mini"
              type="primary"
            >
              更换</el-button
            >
          </div>
        </div>
      </div>

      <div
        class="object-tool"
        v-if="
          project.type != '2' &&
          project.type != '3' &&
          project.type != '4' &&
          isLeader
        "
        style="margin-bottom: 10px"
      >
        <div class="btn-room">
          <router-link v-if="project.wxType != 'A'" :to="'/Project/updateInfo/' + project.id">
            <el-button size="small" type="primary"
              >点击进行 "项目前期情况登记"</el-button
            >
          </router-link>

          <router-link
            v-if="
              project.status == '立项完成' ||
              project.status == '招标中' ||
              project.status == '招标完成' ||
              project.status == '签订合同中' ||
              project.status == '实施中'
            "
            :to="'/Project/CreateSetup/' + project.id"
          >
            <el-button size="small" type="success">编辑项目立项结果</el-button>
          </router-link>

          <router-link
            v-if="
              project.iszb &&
              (project.status == '招标完成' ||
                project.status == '签订合同中' ||
                project.status == '实施中')
            "
            :to="'/Project/InviteResult/' + project.id"
          >
            <el-button size="small" type="warning"
              >编辑招标情况填录(开标结果)</el-button
            >
          </router-link>
        </div>
      </div>

      <div
        v-if="isLeader && project.level == 0"
        class="object-tool"
        style="margin-bottom: 20px"
      >
        <router-link target="_blank" :to="'/Contract/Create/' + project.id">
          <el-button size="small" type="primary">新建相关的独立合同</el-button>
        </router-link>
        <router-link target="_blank" :to="'/Pay/Create/' + project.id">
          <el-button size="small" type="primary">新建相关的独立支付</el-button>
        </router-link>
        <router-link
          target="_blank"
          :to="'/Storage/MaterialUse/0/' + project.id"
        >
          <el-button size="small" type="primary">发起使用材料申请</el-button>
        </router-link>
      </div>

      <!-- 形象进度 -->
      <div class="progress-list" v-if="progressData.length > 0">
        <h3 class="title">项目形象进度</h3>
        <el-table
          class="projress-table"
          :data="progressData"
          style="width: 100%"
        >
          <el-table-column prop="wcContent" label="已完成工程内容">
          </el-table-column>
          <el-table-column prop="rate" label="完成百分比" width="100px">
          </el-table-column>
          <el-table-column prop="wctze" label="完成投资额" width="110px">
          </el-table-column>
          <el-table-column prop="createTime" label="登记时间" width="120px">
          </el-table-column>
        </el-table>
      </div>

      <!-- 开工登记 -->
      <div class="dengji-box" v-if="kgInfo">
        <h3 class="title">
          项目开工登记
          <router-link
            v-if="isLeader && project.type != '3' && project.type != '4'"
            :to="'/Project/CreateStart/' + project.id"
          >
            <el-button
              size="mini"
              style="margin-left: 10px"
              type="success"
              plain
              >编辑</el-button
            >
          </router-link>
        </h3>
        <div class="dj-content">
          <div class="dj-item">
            <label>开工时间：</label>
            <div class="dj-value">{{ kgInfo.kgsj }}</div>
          </div>
          <div class="dj-item">
            <label>开工情况说明：</label>
            <div class="dj-value">{{ kgInfo.kgqksm }}</div>
          </div>
        </div>
      </div>
      <!-- 验收登记 -->
      <div class="dengji-box" v-if="ysInfo">
        <h3 class="title">
          项目验收登记
          <router-link v-if="isLeader" :to="'/Project/CreateEnd/' + project.id">
            <el-button
              size="mini"
              style="margin-left: 10px"
              type="success"
              plain
              >编辑</el-button
            >
          </router-link>
        </h3>
        <div class="dj-content">
          <div class="dj-item">
            <label>验收时间：</label>
            <div class="dj-value">{{ ysInfo.yssj }}</div>
          </div>
          <div class="dj-item">
            <label>验收情况说明：</label>
            <div class="dj-value">{{ ysInfo.ysqksm }}</div>
          </div>
        </div>
      </div>
      <!-- 结案登记 -->
      <div class="dengji-box" v-if="jaInfo">
        <h3 class="title">
          项目结案登记
          <router-link
            v-if="isLeader && project.type != '3' && project.type != '4'"
            :to="'/Project/EndRegister/' + project.id"
          >
            <el-button
              size="mini"
              style="margin-left: 10px"
              type="success"
              plain
              >编辑</el-button
            >
          </router-link>
        </h3>
        <div class="dj-content ja-dj-content">
          <div class="clear">
            <div class="dj-item">
              <label>一审结算价：</label>
              <div class="dj-value">{{ jaInfo.ysjsj }} 元</div>
            </div>
            <div class="dj-item">
              <label>一审审核单位：</label>
              <div class="dj-value">{{ jaInfo.ysshdw }}</div>
            </div>
          </div>
          <div class="clear">
            <div class="dj-item">
              <label>二审结算价：</label>
              <div class="dj-value">{{ jaInfo.esjsj }} 元</div>
            </div>
            <div class="dj-item">
              <label>二审审核单位：</label>
              <div class="dj-value">{{ jaInfo.esshdw }}</div>
            </div>
          </div>
          <div class="clear">
            <div class="dj-item">
              <label>财政局审核价：</label>
              <div class="dj-value">{{ jaInfo.czjshj }} 元</div>
            </div>
            <div class="dj-item">
              <label>审核单位：</label>
              <div class="dj-value">{{ jaInfo.shdw }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目操作 -->
      <div class="object-tool" v-if="isKxLeader">
        <div class="wait-tip" v-if="waitMessage">{{ waitMessage }}</div>
        <div class="next-worker" v-else>
          <h3 class="title">接下来您可以</h3>
          <div class="btn-room">
            <router-link :to="'/Project/CreateMoneyApproval/' + project.id">
              <el-button size="small" type="success" plain
                >项目付款审核意见单</el-button
              >
            </router-link>
          </div>
        </div>
      </div>
      <div class="object-tool" v-if="isLeader">
        <div class="wait-tip" v-if="waitMessage">{{ waitMessage }}</div>
        <div class="next-worker" v-else>
          <h3 class="title">接下来您可以</h3>
          <div class="btn-room">
            <!-- 项目立项 -->
            <div
              class="project-tool-box"
              v-if="
                project.type != '3' &&
                project.type != '4' &&
                project.status == '申请完成' &&
                (!project.team ||
                  (project.team && project.team.name != '应急工程'))
              "
            >
              <router-link :to="'/Project/CreateSetup/' + project.id">
                <el-button size="small" type="success" plain
                  >提交项目立项结果</el-button
                >
              </router-link>
              <el-button
                size="small"
                @click="projectStatusUpdate('立项完成')"
                type="success"
                plain
                >跳过立项(可后补)</el-button
              >
            </div>

            <!-- 项目招标 -->
            <div
              class="project-tool-box"
              v-if="
                project.type != '3' &&
                project.type != '4' &&
                project.iszb &&
                ((project.team &&
                  project.team.name == '应急工程' &&
                  project.status == '申请完成') ||
                  project.status == '立项完成' ||
                  project.status == '招标中')
              "
            >
              <p class="tip">
                注：招标情况填录(开标结果)登记后，将进入合同签订环节。
              </p>
              <router-link :to="'/Project/CreateInvite/' + project.id">
                <el-button size="small" type="success" plain
                  >项目招标控制价审批</el-button
                >
              </router-link>
              <router-link
                v-if="project.wxType != 'A'"
                :to="'/Project/CreateInviteApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >招标文件审核会签表</el-button
                >
              </router-link>
              <router-link :to="'/Project/InviteResult/' + project.id">
                <el-button size="small" type="primary"
                  >招标情况填录(开标结果)</el-button
                >
              </router-link>
              <!-- <el-button @click="projectStatusUpdateZB('招标完成')" size="small" type="primary">设置招标完成(线下招标完成)</el-button> -->
            </div>

            <!-- 项目招标审批表补录 -->
            <div
              class="project-tool-box"
              v-if="
                (!project.inviteflows.length ||
                  !project.inviteSignflows.length) &&
                project.type != '3' &&
                project.type != '4' &&
                project.iszb &&
                project.status != '申请完成' &&
                project.status != '立项完成' &&
                project.status != '招标中'
              "
            >
              <router-link
                v-if="!project.inviteflows.length"
                :to="'/Project/CreateInvite/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >项目招标控制价审批</el-button
                >
              </router-link>
              <router-link
                v-if="project.wxType != 'A' && !project.inviteSignflows.length"
                :to="'/Project/CreateInviteApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >招标文件审核会签表</el-button
                >
              </router-link>
            </div>

            <div
              class="project-tool-box"
              v-if="
                (project.type == '3' || project.type == '4') &&
                project.status == '申请完成'
              "
            >
              <router-link :to="'/Project/CreateBudget/' + project.id">
                <el-button size="small" type="success" plain
                  >预算（招标控制价）审批</el-button
                >
              </router-link>
            </div>

            <!-- 合同 -->
            <div
              class="project-tool-box"
              v-if="
                ((project.type == '3' || project.type == '4') &&
                  project.status == '预算及设计审批完成') ||
                (!project.iszb &&
                  (project.status == '立项完成' ||
                    (project.team &&
                      project.team.name == '应急工程' &&
                      project.status == '申请完成'))) ||
                (project.iszb && project.status == '招标完成') ||
                project.status == '签订合同中'
              "
            >
              <router-link
                v-if="!project.contractSignflows.length > 0"
                :to="'/Project/CreateContractApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >合同会签审批表</el-button
                >
              </router-link>
              <p style="padding: 10px 0" v-else>请等待合同会签完成...</p>

              <router-link
                :to="'/Project/CreateContractRecordApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >合同备案审批表</el-button
                >
              </router-link>
            </div>

            <!-- 实施中，已完成 -->
            <div
              v-if="project.status == '实施中' || project.status == '已完成'"
              class="project-tool-box"
            >
              <router-link
                v-if="!project.contractRecordflows.length > 0"
                :to="'/Project/CreateContractRecordApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >合同备案审批表</el-button
                >
              </router-link>
              <router-link
                v-if="!project.contractSignflows.length > 0"
                :to="'/Project/CreateContractApproval/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >合同会签审批表</el-button
                >
              </router-link>

              <router-link
                v-if="project.type != '3' && project.type != '4'"
                :to="'/Project/CreateProgress/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >项目形象进度填报</el-button
                >
              </router-link>
              <router-link :to="'/Project/CreatePayApproval/' + project.id">
                <el-button size="small" type="success" plain
                  >工程款项支付审批</el-button
                >
              </router-link>
            </div>
            <div
              v-if="project.status == '实施中' || project.status == '已完成'"
              class="project-tool-box"
            >
              <router-link
                v-if="project.type != '3' && project.type != '4' && !kgInfo"
                :to="'/Project/CreateStart/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >项目开工登记</el-button
                >
              </router-link>
              <router-link
                v-if="!ysInfo"
                :to="'/Project/CreateEnd/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >项目竣工验收登记</el-button
                >
              </router-link>
              <router-link
                v-if="project.type != '3' && project.type != '4' && !jaInfo"
                :to="'/Project/EndRegister/' + project.id"
              >
                <el-button size="small" type="success" plain
                  >项目结案登记</el-button
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-tabs class="project-tabs" v-model="tabItem" type="border-card">
      <!-- <el-tab-pane label="项目详情">
        <info :project="project" v-if="'0' === tabItem"></info>
      </el-tab-pane> -->
      <el-tab-pane label="项目详情">
        <info
          :isLeader="isLeader"
          :isKxLeader="isKxLeader"
          :project="project"
          v-if="'0' === tabItem"
        ></info>
      </el-tab-pane>
      <el-tab-pane label="相关合同">
        <contract-list
          :projectId="projectId"
          v-if="'1' === tabItem"
        ></contract-list>
      </el-tab-pane>
      <el-tab-pane label="相关文档">
        <file
          :isLeader="isLeader"
          :projectId="projectId"
          v-if="'2' === tabItem"
        ></file>
      </el-tab-pane>
      <el-tab-pane label="相关会议">
        <metting :projectId="projectId" v-if="'3' === tabItem"></metting>
      </el-tab-pane>
      <el-tab-pane label="相关材料">
        <material :projectId="projectId" v-if="'4' === tabItem"></material>
      </el-tab-pane>

      <el-tab-pane label="相关采购">
        <purchase :projectId="projectId" v-if="'5' === tabItem"></purchase>
      </el-tab-pane>

      <el-tab-pane label="关联项目">
        <project-list
          :projectId="projectId"
          v-if="'6' === tabItem"
        ></project-list>
      </el-tab-pane>
      <el-tab-pane label="同项目组项目">
        <team :projectId="projectId" v-if="'7' === tabItem"></team>
      </el-tab-pane>
    </el-tabs>

    <project-info></project-info>

    <!-- 修改项目名和简介的弹窗 -->
    <div class="pop-room project-edit-pop" v-if="editStatus">
      <a
        href="javascript:;"
        @click="editStatus = false"
        class="iconfont icon-close"
      ></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="项目名称">
              <el-input
                size="small"
                v-model="form.name"
                placeholder="请输入项目名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目介绍">
              <el-input
                type="textarea"
                placeholder="需求工程项目情况介绍（需求情况、目的、要求及意义）"
                :autosize="{ minRows: 5, maxRows: 8 }"
                size="small"
                v-model="form.intro"
              ></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="EditBtnClick()" class="form-btn" type="success"
                >确认提交</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import Role from "@/Mixins/role";
import projectInfo from "../user/projectInfo";
import Info from "./info";
// import Approval from './approval'
import Metting from "./metting";
import File from "./file";
import Team from "./team";
import ProjectList from "./projectlist";
import ContractList from "./contractlist";
import Material from "./material";
import Purchase from "./purchase";

import ObjectUtil from "./mixins/objectUtil";
export default {
  computed: {
    ...mapState({
      contactSelectArr: (state) => state.main.contactSelectArr,
      contactType: (state) => state.main.contactType,
      userData: (state) => state.main.userData,
      projectReload: (state) => state.main.projectReload,
    }),
  },
  mixins: [Role, ObjectUtil],
  data() {
    return {
      tabItem: "0",
      projectId: "",
      project: "",
      // 选择更换项目负责人
      leaderType: 1,
      selectArr: [],
      // 是否有编辑权限
      isLeader: false,
      // 是否有款项负责人权限
      isKxLeader: false,

      waitMessage: "",
      progressData: "",

      // 开工登记
      kgInfo: "",
      // 验收登记
      ysInfo: "",
      // 结案登记
      jaInfo: "",

      // 修改弹窗
      editStatus: false,
      form: {
        projectId: "",
        name: "",
        intro: "",
      },
    };
  },
  components: {
    Info,
    // Approval,
    Metting,
    File,
    Team,
    projectInfo,
    ProjectList,
    ContractList,
    Material,
    Purchase,
  },
  beforeRouteLeave(to, from, next) {
    // 初始化项目审核表
    this.$store.commit("set_projectTable", {
      status: false,
      applyId: "",
      tableType: "",
    });
    next();
  },
  created() {
    this.projectId = this.$route.params.id;
  },
  mounted() {
    this.getDetail();

    this.getKgInfo();
    this.getYsInfo();
    this.getJaInfo();
  },
  methods: {
    // 提交修改
    EditBtnClick() {
      ajax.post("/gc/project/edit/name", this.form, (res) => {
        this.editStatus = false;
        this.$message.success("修改工程资料成功");
        this.getDetail();
      });
    },
    // 修改项目名和简介
    editProjectInfo() {
      this.form.projectId = this.project.id;
      this.form.name = this.project.name;
      this.form.intro = this.project.intro;
      this.editStatus = true;
    },
    // 开工登记
    getKgInfo() {
      ajax.get("/gc/project/kg/info/" + this.projectId, "", (res) => {
        this.kgInfo = res.vo ? res.vo : "";
      });
    },
    // 验收登记
    getYsInfo() {
      ajax.get("/gc/project/ys/info/" + this.projectId, "", (res) => {
        this.ysInfo = res.vo ? res.vo : "";
      });
    },
    // 结案登记
    getJaInfo() {
      ajax.get("/gc/project/end/register/info/" + this.projectId, "", (res) => {
        this.jaInfo = res.vo ? res.vo : "";
      });
    },
    // 删除项目
    deleteProject() {
      this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ajax.post("/gc/project/del/" + this.projectId, "", (res) => {
            this.$message.error("删除项目成功");
            // 返回列表
            this.$router.push("/Project/List");
          });
        })
        .catch(() => {});
    },
    // 设置项目状态
    projectStatusUpdate(statusText) {
      ajax.post(
        "/gc/project/status/update",
        {
          projectId: this.projectId,
          status: statusText,
        },
        (res) => {
          this.$message.success("设置" + statusText + "成功");
          this.getDetail();
        }
      );
    },
    // 设置项目招标结束
    projectStatusUpdateZB(typeText) {
      this.$confirm(
        "该操作将直接设置项目状态为『" +
          typeText +
          "』，设置后，将跳过『" +
          typeText +
          "』前所有步骤，直接进入下一个流程，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.projectStatusUpdate(typeText);
        })
        .catch(() => {});
    },
    // 设置项目废弃
    projectStatusUpdateCancle() {
      this.$router.push({
        path: "/Project/CreateDiscard",
        query: {
          projectId: this.project.id,
        },
      });
      // this.$confirm('该操作将直接设置项目状态为『' + typeText + '』，设置后，将结束所有本项目相关工作流程，该过程不可逆，是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.projectStatusUpdate(typeText)
      // }).catch(() => {});
    },
    // 选择更换项目/款项负责人
    addUsers(type) {
      this.leaderType = type;
      let _sr = [];
      switch (type) {
        case 1:
          _sr.push(this.project.leader);
          break;
        case 2:
          if (this.project.kxLeader) {
            _sr.push(this.project.kxLeader);
          }
          break;
      }
      this.$store.commit("set_contactSelectArr", _sr);
      this.$store.commit("set_contactShow", true);
      this.$store.commit("set_contactSingleSelect", true);
    },
    // 获取形象进度
    getProject() {
      ajax.get("/gc/project/speed/list/" + this.project.id, "", (res) => {
        this.progressData = res.vo.array;
      });
    },
    // 获取详情
    getDetail() {
      ajax.get("/gc/project/detail/" + this.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);

        if (
          this.project.leader.id == this.userData.id ||
          this.project.creator.id == this.userData.id
        ) {
          this.isLeader = true;
        }
        // this.isLeader = this.project.leader.id == this.userData.id
        this.isKxLeader =
          this.project.kxLeader && this.project.kxLeader.id == this.userData.id;

        // title
        document.title = this.project.name + " - 象山水务集团";

        // 当前状态判断
        switch (this.project.status) {
          case "申请中":
            this.waitMessage = "请等待项目申请审批完成";
            break;
          case "预算及设计审批中":
            this.waitMessage = "请等待项目预算及设计审批完成";
            break;
          default:
            this.waitMessage = "";
            break;
        }

        this.getProject();

        // 判断是否填过项目前期情况
        if (
          this.isLeader &&
          this.project.state != "申请中" &&
          this.project.state != "申请完成"
        ) {
          if (
            this.project.type != "2" &&
            this.project.type != "3" &&
            this.project.type != "4" &&
            this.project.wxType != "A" &&
            !this.project.lxUptime
          ) {
            this.$confirm(
              "检测到你还没有进行过『前期情况登记』，是否立即进入登记?『前期情况登记』是领导了解项目情况的一个重要途径，请经常更新登记。",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.$router.push("/Project/updateInfo/" + this.project.id);
              })
              .catch(() => {});
          }
        }

        // 重新请求project结束
        this.$store.commit("set_projectReload", false);
      });
    },
    // 更换项目负责人
    leaderUpdate() {
      console.log(this.selectArr);
      if (this.selectArr.length < 1) {
        return;
      }
      this.$confirm(
        "你确定要将项目管理权限转移至" +
          this.selectArr[0].name +
          "? 此操作将使你失去项目的管理权限。",
        "更换项目负责人",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          ajax.post(
            "/gc/project/leader/update",
            {
              projectId: this.project.id,
              userId: this.selectArr[0].id,
            },
            (res) => {
              this.getDetail();
            }
          );
        })
        .catch(() => {});
    },
    // 更换款项负责人
    kxLeaderUpdate() {
      console.log(this.selectArr);
      if (this.selectArr.length < 1) {
        return;
      }
      this.$confirm(
        "你确定要将项目进度款审核管理权限转移至" +
          this.selectArr[0].name +
          "? ",
        "更换款项负责人",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          ajax.post(
            "/gc/project/kx/leader/update",
            {
              projectId: this.project.id,
              userId: this.selectArr[0].id,
            },
            (res) => {
              this.getDetail();
            }
          );
        })
        .catch(() => {});
    },
  },
  watch: {
    contactSelectArr() {
      if (this.contactSelectArr.length < 1 || this.contactType) {
        return;
      }
      this.selectArr = this.contactSelectArr;
      if (
        this.contactSelectArr[0].id != this.project.leader.id &&
        this.leaderType == 1
      ) {
        this.leaderUpdate();
      }
      if (this.leaderType == 2) {
        if (
          this.project.kxLeader &&
          this.contactSelectArr[0].id != this.project.kxLeader.id
        ) {
          this.kxLeaderUpdate();
        }
        if (!this.project.kxLeader) {
          this.kxLeaderUpdate();
        }
      }
    },
    $route(to, from) {
      this.projectId = this.$route.params.id;
      this.getDetail();
      this.tabItem = "0";
    },
    projectReload() {
      if (this.projectReload) {
        this.getDetail();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/detail.vue